import IconButton from "components/common/IconButton";
import SoftBadge from "components/common/SoftBadge";
import PropTypes from 'prop-types';
import React, { useState } from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import { FiAlertCircle, FiCheckCircle, FiEdit, FiMail, FiUser } from 'react-icons/fi';
import { Link } from "react-router-dom";
import ModalEnviarEncuesta from './ModalEnviarEncuesta';

const ComentarioItem = ({
    comentario,
    editandoId,
    resolviendoId,
    editandoSolucionId,
    textoEditado,
    setTextoEditado,
    textoSolucion,
    setTextoSolucion,
    textoSolucionEditado,
    setTextoSolucionEditado,
    nivelSoporteSeleccionado,
    setNivelSoporteSeleccionado,
    minutosInvertidos,
    setMinutosInvertidos,
    nivelSoporteEditado,
    setNivelSoporteEditado,
    minutosInvertidosEditado,
    setMinutosInvertidosEditado,
    nivelesSoporte,
    cargandoNiveles,
    cargandoImagenes,
    solucionTextareaRef,
    minutosRef,
    nivelRef,
    iniciarEdicion,
    cancelarEdicion,
    guardarEdicion,
    iniciarResolucion,
    cancelarResolucion,
    guardarResolucion,
    iniciarEdicionSolucion,
    cancelarEdicionSolucion,
    guardarEdicionSolucion,
    emailCliente,
    setComentarios
}) => {
    const [showModal, setShowModal] = useState(false);

    console.log("comentario", comentario)
    return (
        <Col xs={12}>
            <div
                style={{
                    padding: "12px 16px",
                    border: "1px solid #e3e3e3",
                    borderRadius: "8px",
                    background: "transparent",
                    transition: "all 0.2s ease",
                    cursor: "default",
                    position: "relative"
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = "#0d6efd";
                    e.currentTarget.style.boxShadow = "0 2px 8px rgba(13, 110, 253, 0.15)";
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = "#e3e3e3";
                    e.currentTarget.style.boxShadow = "none";
                }}
            >
                {/* IP en esquina superior derecha */}
                {comentario.vIP && (
                    <code style={{
                        position: "absolute",
                        top: "12px",
                        right: "16px",
                        fontSize: "0.7rem",
                        padding: "2px 6px",
                        background: "#f8f9fa",
                        borderRadius: "4px",
                        color: "#6c757d"
                    }}>
                        {comentario.vIP}
                    </code>
                )}

                {/* Botón Enviar Encuesta o Leyenda Encuesta Enviada */}
                {(comentario.bResuelto || comentario.vEstado === "Resuelto") && comentario.vIP && (
                    <div style={{
                        position: "absolute",
                        top: "35px",
                        right: "16px"
                    }}>
                        {comentario.vCorreoElectronicoEncuesta ? (
                            <SoftBadge bg="info" className="fs--1">
                                Encuesta enviada
                            </SoftBadge>
                        ) : (
                            <IconButton
                                variant="outline-primary"
                                size="sm"
                                onClick={() => setShowModal(true)}
                                title="Enviar encuesta por e-mail"
                            >
                                <FiMail size={12} /> Enviar encuesta
                            </IconButton>
                        )}
                    </div>
                )}
             
                <div className="mb-3 d-flex align-items-center" style={{ paddingRight: "50px" }}>
                    {cargandoImagenes[comentario.idUsuario] ? (
                        <div style={{ width: '48px', height: '48px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginRight: '12px' }}>
                            <Spinner animation="border" size="sm" variant="primary" />
                        </div>
                    ) : (
                            <img
                                src={
                                    comentario.vImagenUsuario
                                }
                                style={{
                                    width: '48px',
                                    height: '48px',
                                    borderRadius: '50%',
                                    objectFit: 'cover',
                                    border: '2px solid #e9ecef',
                                    marginRight: '12px',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                }}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = "/img/team/nofoto50.png";
                                }}
                            />
                    )}
                    <div className="flex-grow-1">
                        <h6 className="mb-1 fw-bold text-dark" style={{ fontSize: "1rem", marginBottom: "4px" }}>
                            <FiUser size={16} className="text-primary me-2" />
                            <Link className="fw-semi-bold fs--2" to={"/perfil/" + comentario.idUsuario} style={{ fontSize: "1rem" }}>
                                {comentario.vNombreUsuario}
                            </Link>
                        </h6>
                        <small className="text-muted" style={{ fontSize: "0.75rem" }}>
                            {comentario.vFecha} • {comentario.vHora} |
                            <SoftBadge bg={comentario.bResuelto || comentario.vEstado === "Resuelto" ? "success" : "danger"}>
                                {comentario.vEstado || (comentario.bResuelto ? "Resuelto" : "Soporte")}
                            </SoftBadge>
                        </small>
                    </div>
                </div>

                {/* Problema */}
                <div className="mb-1">
                    <FiAlertCircle size={13} className="text-warning me-1" style={{ verticalAlign: "middle" }} />
                    <span className="fw-bold text-700" style={{ fontSize: "0.8rem" }}>Problema: </span>
                    {editandoId === comentario.idClientesAkasiaComentariosProblema ? (
                        <div className="mt-2">
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={textoEditado}
                                onChange={(e) => setTextoEditado(e.target.value)}
                                maxLength={999}
                                minLength={15}
                                style={{ resize: "none", fontSize: "0.8rem" }}
                            />
                            {textoEditado.length > 0 && textoEditado.length < 15 && (
                                <small className="text-muted">
                                    M&iacute;nimo 15 caracteres ({textoEditado.length}/15)
                                </small>
                            )}
                            <div className="mt-2">
                                <IconButton
                                    variant="success"
                                    size="sm"
                                    icon="check"
                                    onClick={() => guardarEdicion(comentario)}
                                    className="me-2"
                                >
                                    <span className="d-none d-sm-inline ms-1">Guardar</span>
                                </IconButton>
                                <IconButton
                                    variant="secondary"
                                    size="sm"
                                    icon="times"
                                    onClick={cancelarEdicion}
                                >
                                    <span className="d-none d-sm-inline ms-1">Cancelar</span>
                                </IconButton>
                            </div>
                        </div>
                    ) : (
                        <>
                            <span className="text-dark" style={{
                                fontSize: "0.8rem",
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word"
                            }} dangerouslySetInnerHTML={{ __html: comentario.vProblema }} />
                            <FiEdit
                                size={13}
                                className="ms-2 text-warning"
                                style={{ cursor: "pointer", verticalAlign: "middle" }}
                                title="Editar problema"
                                onClick={() => iniciarEdicion(comentario)
                                }
                            />
                        </>
                    )}
                </div>

                {/* Mostrar solución si existe */}
                {(comentario.bResuelto || comentario.vEstado === "Resuelto" || comentario.vSolucion) && (
                    <>
                        {editandoSolucionId === comentario.idClientesAkasiaComentariosProblema ? (
                            <div className="mt-2 p-2 bg-light rounded">
                                <Row>
                                    <Col md={9} className="mb-3">
                                        <Form.Label className="fw-bold">
                                            Nivel de Soporte: <span className="text-danger">*</span>
                                        </Form.Label>
                                        {cargandoNiveles ? (
                                            <div className="d-flex align-items-center">
                                                <Spinner animation="border" size="sm" variant="primary" className="me-2" />
                                                <span className="text-muted">Cargando niveles...</span>
                                            </div>
                                        ) : (
                                            <Form.Select
                                                value={nivelSoporteEditado}
                                                onChange={(e) => setNivelSoporteEditado(e.target.value)}
                                                isInvalid={!nivelSoporteEditado && textoSolucionEditado.length >= 15}
                                                ref={nivelRef}
                                            >
                                                <option value="">Selecciona un nivel...</option>
                                                {nivelesSoporte.map((nivel) => (
                                                    <option
                                                        key={nivel.idCatNivelSoporte}
                                                        value={nivel.idCatNivelSoporte}
                                                    >
                                                        Nivel {nivel.iNivel} - {nivel.vNombreNivel}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        )}
                                        {!nivelSoporteEditado && textoSolucionEditado.length >= 15 && (
                                            <small className="text-danger">
                                                Debe seleccionar un nivel de soporte
                                            </small>
                                        )}
                                    </Col>
                                    <Col md={3} className="mb-3">
                                        <Form.Label className="fw-bold">
                                            Minutos Invertidos: <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="number"
                                            min="1"
                                            max="9999"
                                            value={minutosInvertidosEditado}
                                            onChange={(e) => setMinutosInvertidosEditado(e.target.value)}
                                            placeholder="Ej: 30"
                                            isInvalid={minutosInvertidosEditado !== "" && (parseInt(minutosInvertidosEditado) <= 0 || isNaN(parseInt(minutosInvertidosEditado)))}
                                            ref={minutosRef}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    guardarEdicionSolucion(comentario);
                                                }
                                            }}
                                        />
                                        {minutosInvertidosEditado !== "" && (parseInt(minutosInvertidosEditado) <= 0 || isNaN(parseInt(minutosInvertidosEditado))) && (
                                            <small className="text-danger">
                                                Debe ingresar un número mayor a 0
                                            </small>
                                        )}
                                    </Col>
                                    <Col md={12}>
                                        <Form.Label className="fw-bold">
                                            Solución: <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            value={textoSolucionEditado}
                                            onChange={(e) => setTextoSolucionEditado(e.target.value)}
                                            maxLength={999}
                                            minLength={15}
                                            placeholder="Describe la solución al problema..."
                                            style={{ resize: "none" }}
                                            ref={solucionTextareaRef}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    if (e.target.value.length >= 15) {
                                                        guardarEdicionSolucion(comentario);
                                                    }
                                                }
                                            }}
                                        />
                                        {textoSolucionEditado.length > 0 && textoSolucionEditado.length < 15 && (
                                            <small className="text-muted">
                                                M&iacute;nimo 15 caracteres ({textoSolucionEditado.length}/15)
                                            </small>
                                        )}
                                    </Col>
                                </Row>
                                <div className="mt-2">
                                    <IconButton
                                        variant="success"
                                        size="sm"
                                        icon="check"
                                        onClick={() => guardarEdicionSolucion(comentario)}
                                        className="me-2"
                                        disabled={cargandoNiveles}
                                    >
                                        <span className="d-none d-sm-inline ms-1">Guardar</span>
                                    </IconButton>
                                    <IconButton
                                        variant="secondary"
                                        size="sm"
                                        icon="times"
                                        onClick={cancelarEdicionSolucion}
                                    >
                                        <span className="d-none d-sm-inline ms-1">Cancelar</span>
                                    </IconButton>
                                </div>
                            </div>
                        ) : (
                            <div className="mt-2 p-2 rounded">
                                <FiCheckCircle size={13} className="text-success me-1" style={{ verticalAlign: "middle" }} />
                                <span className="fw-bold text-success" style={{ fontSize: "0.8rem" }}>SOLUCIÓN:</span>
                                <p className="mb-1 mt-1">
                                    <span dangerouslySetInnerHTML={{ __html: comentario.vSolucion || "Sin detalles de solución" }} />
                                    <FiEdit
                                        size={13}
                                        className="ms-2 text-warning"
                                        style={{ cursor: "pointer", verticalAlign: "middle" }}
                                        title="Editar solución"
                                        onClick={() => iniciarEdicionSolucion(comentario)}
                                    />
                                </p>
                                <small className="text-800">
                                    {comentario.vUsuarioSolucion && (
                                        <>
                                            Resuelto por {comentario.vUsuarioSolucion}
                                            {comentario.vFechaSolucion && (
                                                <> el {comentario.vFechaSolucion}</>
                                            )}
                                            {comentario.vHoraSolucion && (
                                                <> a las {comentario.vHoraSolucion}</>
                                            )}
                                        </>
                                    )}
                                    {(comentario.vTiempoTexto || comentario.dTiempo) && (
                                        <>
                                            {comentario.vUsuarioSolucion && " • "}
                                            Tiempo: <strong>{comentario.vTiempoTexto || `${comentario.dTiempo} min`}</strong>
                                        </>
                                    )}
                                    {comentario.vNombreNivel ? ' | ' : ''}{comentario.vNombreNivel && (
                                        <>
                                            {comentario.iNivel > 2 ? <span className="badge bg-danger">★ {comentario.iNivel}</span> : comentario.iNivel}
                                            {' - ' + comentario.vNombreNivel}
                                        </>
                                    )}
                                </small>
                            </div>
                        )}
                    </>
                )}

                {/* Formulario de resolución */}
                {resolviendoId === comentario.idClientesAkasiaComentariosProblema && (
                    <div className="mt-2">
                        <Row>
                            <Col md={9} className="mb-3">
                                <Form.Label className="fw-bold">
                                    Nivel de Soporte: <span className="text-danger">*</span>
                                </Form.Label>
                                {cargandoNiveles ? (
                                    <div className="d-flex align-items-center">
                                        <Spinner animation="border" size="sm" variant="primary" className="me-2" />
                                        <span className="text-muted">Cargando niveles...</span>
                                    </div>
                                ) : (
                                    <Form.Select
                                        value={nivelSoporteSeleccionado}
                                        onChange={(e) => setNivelSoporteSeleccionado(e.target.value)}
                                        isInvalid={!nivelSoporteSeleccionado && textoSolucion.length >= 15}
                                        ref={nivelRef}
                                    >
                                        <option value="">Selecciona un nivel...</option>
                                        {nivelesSoporte.map((nivel) => (
                                            <option
                                                key={nivel.idCatNivelSoporte}
                                                value={nivel.idCatNivelSoporte}
                                            >
                                                Nivel {nivel.iNivel} - {nivel.vNombreNivel}
                                            </option>
                                        ))}
                                    </Form.Select>
                                )}
                                {!nivelSoporteSeleccionado && textoSolucion.length >= 15 && (
                                    <small className="text-danger">
                                        Debe seleccionar un nivel de soporte
                                    </small>
                                )}
                            </Col>
                            <Col md={3} className="mb-3">
                                <Form.Label className="fw-bold">
                                    Minutos Invertidos: <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    type="number"
                                    min="1"
                                    max="9999"
                                    value={minutosInvertidos}
                                    onChange={(e) => setMinutosInvertidos(e.target.value)}
                                    placeholder="Ej: 30"
                                    isInvalid={minutosInvertidos !== "" && (parseInt(minutosInvertidos) <= 0 || isNaN(parseInt(minutosInvertidos)))}
                                    ref={minutosRef}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            guardarResolucion(comentario);
                                        }
                                    }}
                                />
                                {minutosInvertidos !== "" && (parseInt(minutosInvertidos) <= 0 || isNaN(parseInt(minutosInvertidos))) && (
                                    <small className="text-danger">
                                        Debe ingresar un número mayor a 0
                                    </small>
                                )}
                            </Col>
                            <Col md={12}>
                                <Form.Label className="fw-bold">
                                    Solución: <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={textoSolucion}
                                    onChange={(e) => setTextoSolucion(e.target.value)}
                                    maxLength={999}
                                    minLength={15}
                                    placeholder="Describe la solución al problema..."
                                    style={{ resize: "none" }}
                                    ref={solucionTextareaRef}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            if (e.target.value.length >= 15) {
                                                guardarResolucion(comentario);
                                            }
                                        }
                                    }}
                                />
                                {textoSolucion.length > 0 && textoSolucion.length < 15 && (
                                    <small className="text-muted">
                                        M&iacute;nimo 15 caracteres ({textoSolucion.length}/15)
                                    </small>
                                )}
                            </Col>
                        </Row>
                        <div className="mt-2">
                            <IconButton
                                variant="success"
                                size="sm"
                                icon="check"
                                onClick={() => guardarResolucion(comentario)}
                                className="me-2"
                                disabled={cargandoNiveles}
                            >
                                <span className="d-none d-sm-inline ms-1">Guardar Solución</span>
                            </IconButton>
                            <IconButton
                                variant="secondary"
                                size="sm"
                                icon="times"
                                onClick={cancelarResolucion}
                            >
                                <span className="d-none d-sm-inline ms-1">Cancelar</span>
                            </IconButton>
                        </div>
                    </div>
                )}

                {/* Botón Resolver */}
                {editandoId !== comentario.idClientesAkasiaComentariosProblema &&
                    resolviendoId !== comentario.idClientesAkasiaComentariosProblema &&
                    editandoSolucionId !== comentario.idClientesAkasiaComentariosProblema && (
                        <>
                            {!(comentario.bResuelto || comentario.vEstado === "Resuelto" || comentario.vSolucion) && (
                                <div className="mt-2">
                                    <Link
                                        className="fw-semi-bold fs--2 text-success"
                                        to="#"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            iniciarResolucion(comentario);
                                        }}
                                    >
                                        <FiCheckCircle className="me-1" />
                                        Resolver
                                    </Link>
                                </div>
                            )}
                        </>
                    )}
            </div>

            <ModalEnviarEncuesta
                showModal={showModal}
                setShowModal={setShowModal}
                comentario={comentario}
                emailCliente={emailCliente}
                setComentarios={setComentarios}
            />
        </Col>
    );
};

ComentarioItem.propTypes = {
    comentario: PropTypes.object.isRequired,
    editandoId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    resolviendoId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    editandoSolucionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    textoEditado: PropTypes.string.isRequired,
    setTextoEditado: PropTypes.func.isRequired,
    textoSolucion: PropTypes.string.isRequired,
    setTextoSolucion: PropTypes.func.isRequired,
    textoSolucionEditado: PropTypes.string.isRequired,
    setTextoSolucionEditado: PropTypes.func.isRequired,
    nivelSoporteSeleccionado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    setNivelSoporteSeleccionado: PropTypes.func.isRequired,
    minutosInvertidos: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    setMinutosInvertidos: PropTypes.func.isRequired,
    nivelSoporteEditado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    setNivelSoporteEditado: PropTypes.func.isRequired,
    minutosInvertidosEditado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    setMinutosInvertidosEditado: PropTypes.func.isRequired,
    nivelesSoporte: PropTypes.array.isRequired,
    cargandoNiveles: PropTypes.bool.isRequired,
    imagenesPerfil: PropTypes.object.isRequired,
    cargandoImagenes: PropTypes.object.isRequired,
    solucionTextareaRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
    minutosRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
    nivelRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
    iniciarEdicion: PropTypes.func.isRequired,
    cancelarEdicion: PropTypes.func.isRequired,
    guardarEdicion: PropTypes.func.isRequired,
    iniciarResolucion: PropTypes.func.isRequired,
    cancelarResolucion: PropTypes.func.isRequired,
    guardarResolucion: PropTypes.func.isRequired,
    iniciarEdicionSolucion: PropTypes.func.isRequired,
    cancelarEdicionSolucion: PropTypes.func.isRequired,
    guardarEdicionSolucion: PropTypes.func.isRequired,
    emailCliente: PropTypes.string,
    setComentarios: PropTypes.func.isRequired
};

export default ComentarioItem;
